import {PageDoc} from "./PageDoc";
import {PostItem} from "./PostItem";

export class UploadFile {
   id:number=0;
   uid:string="";
   name:string="";
   path:string="";
   file_type:string="";
   type:string="";
  used:boolean=false;
}

